import BannerImage from 'url:public/images/banner.webp'
import BannerMobImage from 'url:public/images/banner-mob.webp'
import LogoImage from 'url:public/logo.webp'
import LogoSmallImage from 'url:public/logo-small.webp'

export const imageMap = {
  banner: BannerImage,
  'banner-mob': BannerMobImage,
  logo: LogoImage,
  'logo-small': LogoSmallImage,
} as const

export type ImageName = keyof typeof imageMap
